// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/prefer-default-export */
import {init, getFeatureFlag} from '@simpleinvest/front-end-remote-config';

const client = init({
  sdkKey: process.env.VUE_APP_CONFIGCAT_ADVISOR_PLATFORM_SDK_KEY as string,
});

export const advisorDirectedOnboarding = (): Promise<boolean> =>
  getFeatureFlag(client, 'ADVISOR_DIRECTED_ONBOARDING', false);

export const ga4PocFlag = (): Promise<boolean> => getFeatureFlag(client, 'GA4_POC', false);

export const uploadDocumentFlag = (): Promise<boolean> => getFeatureFlag(client, 'CLAMAV_UPLOAD_DOCUMENT_FF', false);

export const enableAdvisorSsoLogin = (): Promise<boolean> => getFeatureFlag(client, 'ENABLE_ADVISOR_SSO_LOGIN', false);
